import { oc } from "@orpc/contract";
import { z } from "zod";
import { GetFieldSchemaResponseSchema } from "./e844sd-field-schema.contract";

export const e849FieldSchemaContracts = {
  getSchema: oc.input(z.object({})).output(GetFieldSchemaResponseSchema).route({
    summary: "Get 849 claim response field schema",
    description:
      "Returns the canonical 849 claim response fields with display labels and formats, used for supplier response configuration and columns.",
    method: "GET",
  }),
} as const;
